import React, { useContext } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useDeleteStaffBenefit } from '../../api/staff-benefit'
import { useSnackbar } from 'notistack'
import { StaffBenefitContext } from './StaffBenefitTable'

export const DeleteStaffBenefitCodeDialog = (props) => {
  const { openDelete, row, onClose } = props
  const { mutateAsync } = useDeleteStaffBenefit()
  const { refetch } = useContext(StaffBenefitContext)
  const { enqueueSnackbar } = useSnackbar()

  const handleCancel = () => {
    onClose()
  }

  const handleDeleteStaffBenefit = async () => {
    const res = await mutateAsync({ staffBenefitId: row.id }).catch((e) => {
      enqueueSnackbar('Fail to delete', {
        variant: 'error',
      })
    })
    if (res.status === 200) {
      enqueueSnackbar(`${row.name} deleted`, {
        variant: 'success',
      })
      refetch()
      onClose()
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle id='edit-endDate-title'>Are you sure?</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Do you want to delete{' '}
          <b>
            {row.name}({row.staffBenefitCode})
          </b>
          ? This process cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={handleCancel}>
          Cancel
        </Button>
        <Button
          style={{ backgroundColor: 'black', color: 'white' }}
          onClick={handleDeleteStaffBenefit}
        >
          Yes, delete it
        </Button>
      </DialogActions>
    </Dialog>
  )
}
